let _gaEvents = {
    'callRequest': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'flex-popup',
        'dlEventLabel': 'soittopyynto'
    },
    'offerRequest': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'tarjouspyynto'
    },
    'contact': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'yhteydenotto'
    },
    'roofSurvey': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'kattoturvakatselmus'
    },
    'demonstration': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'asennusnaytos'
    },
    'feedback': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'asiakaspalaute'
    },
    'recruiting': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'rekrylomake'
    },
    'orderOfferGuide': {
        'event': 'conversion',
        'dlEventCategory': 'konversio',
        'dlEventAction': 'lomake',
        'dlEventLabel': 'tarjouspyyntoopas'
    }
};

export default class DataLayer {

    static get gaEvents() {
        return _gaEvents;
    }

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Init
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
    }

    /**
     * Create and push conversion event to Google DataLayer,
     * parse userData from URL params.
     *
     * @param {Object} event The GA event object.
     */
    pushConversionEvent(event) {
        window.dataLayer = window.dataLayer || [];

        const urlParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlParams.entries());

        // If there are URL parameters, parse the keys starting with 'user_' and push to DataLayer.
        if (Object.keys(params).length > 0) {
            const userData = Object.keys(params)
                .filter(key => key.startsWith('user_'))
                .reduce((obj, key) => {
                    obj[key.slice(5)] = params[key];
                    return obj;
                }, {});
            event.userData = userData;
        }

        try {
            window.dataLayer.push(event);
        } catch( e ) {
            console.error( 'An error occured when sending Google event.', e );
        }
    }
}
